function scrollToRef(ref, offset = 0) {
	window.scroll({
		top: ref.current.offsetTop + offset,
		left: 0,
		behavior: 'smooth',
	});
}

export default scrollToRef;
